import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import SidebarSubtitle
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker/Details/Content/SidebarSubtitle';
import fr from 'facet-rest';
import FacetTabs from 'Components/ComponentLibrary/Molecules/Tabs';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import AddIcon from '@material-ui/icons/Add';
import KabobMenu from 'Views/Page/Content/Templates/WhatIfTemplate/Components/KabobMenu';
import KabobMenuItem from 'Views/Page/Content/Templates/WhatIfTemplate/Components/KabobMenu/KabobMenuItem';
import { pickFunction } from 'Helpers/Affordances';
import BalanceSheetTabContent from './BalanceSheetTabContent';
import { useSummarySidebarContentContext } from '../../../Context';

const useStyles = buildUseStyles('BalanceSheet', (() => ({
  root: {},
  subtitleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
})));

const BalanceSheet = ({ balanceSheetResource }) => {
  const classes = useStyles();
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { pageContentResource } = usePageContentContext();

  const {
    sidebarTabs,
    activeSidebarTab,
    setActiveSidebarTab,
    activeSidebarTabData,
    handleAddAccount,
    handleAddRealAsset,
  } = useSummarySidebarContentContext();

  return (
    <Box
      className={classes.root}
    >
      <div className={classes.subtitleRow}>
        <SidebarSubtitle title={'Balance Sheet'} />
        <KabobMenu
          icon={AddIcon}
          test={'facet-plan-balance-sheet-add-item'}
        >
          {pickFunction(balanceSheetResource, {
            [fr.relationships.addAccount.name]: () => (
              <KabobMenuItem
                label={'Add Account'}
                onClick={() => {
                  logStandardizedEvent(categories.whatIf, eventTypes.clickButton, 'Scenario - Create New Virtual Account - General', {
                    eventProperties: {
                      scenarioId: pageContentResource.id(),
                    },
                  });

                  return handleAddAccount(balanceSheetResource);
                }}
              />
            ),
            [fr.relationships.default.name]: () => null,
          })}
          {pickFunction(balanceSheetResource, {
            [fr.relationships.addRealAsset.name]: () => (
              <KabobMenuItem
                label={'Add Real Asset'}
                onClick={() => {
                  logStandardizedEvent(categories.whatIf, eventTypes.clickButton, 'Scenario - Create New Real Asset - General', {
                    eventProperties: {
                      scenarioId: pageContentResource.id(),
                    },
                  });

                  return handleAddRealAsset(balanceSheetResource);
                }}
              />
            ),
            [fr.relationships.default.name]: () => null,
          })}
        </KabobMenu>
      </div>
      <FacetTabs
        onChange={(e, value) => setActiveSidebarTab(value)}
        value={activeSidebarTab}
        tabs={sidebarTabs}
        variant={'fullWidth'}
        TabProps={{
          classes: {
            wrapper: classes.balanceSheetTab,
          },
        }}
      />
      <BalanceSheetTabContent tabData={activeSidebarTabData} />
    </Box>
  );
};

BalanceSheet.propTypes = {
  balanceSheetResource: PropTypes.object.isRequired,
};

export default BalanceSheet;
